import { Subject, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VideoPlaybackService {
  get rewind$(): Observable<void> {
    return this._rewind$.asObservable();
  }

  get rewinding$(): Observable<void> {
    return this._rewind$.asObservable();
  }

  get rewindStop$(): Observable<void> {
    return this._rewindStop$.asObservable();
  }

  get rewindPause$(): Observable<void> {
    return this._rewindPause$.asObservable();
  }

  private readonly _rewind$ = new Subject<void>();
  private readonly _rewindStop$ = new Subject<void>();
  private readonly _rewinding$ = new Subject<void>();
  private readonly _rewindPause$ = new Subject<void>();

  constructor() {}

  public rewindInit(): void {
    this._rewind$.next();
  }

  public rewinding(): void {
    this._rewinding$.next();
  }

  public rewindStop(): void {
    this._rewindStop$.next();
  }

  public rewindPause(): void {
    this._rewindPause$.next();
  }
}
